import * as S from './verify-email-header.styles';

const VerifyEmailHeader = ({ title }) => {
  return (
    <S.ContentHeader variant="h5" aria-label={title}>
      {title}
    </S.ContentHeader>
  );
};

export default VerifyEmailHeader;
